import { Button, Flex, Heading, Icon, Text, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useLazyQuery, useMutation } from '@apollo/client';
import { DOWNLOAD_LAST, GETLASTUPLOADEDFILE } from '../../graphql/query';
import { UPLOADFILE } from '../../graphql/mutation';
import '../../assets/css/Dropzone.css';
import { downloadFile } from './helper';
import { MdDownload } from 'react-icons/md';

function Dropzone(props: {
  boxName: string;
  myFunction: () => void;
  container: string;
}) {
  const toast = useToast();

  let container = props.container;
  const { getRootProps } = useDropzone({
    multiple: false,
    maxFiles: 1,
    accept: '.xlsx, .xls',
    onDrop: (acceptedFiles: File[]) => {
      container = 'container';
      const element = document.getElementById(props.boxName);
      element.className = 'container';
      const file = acceptedFiles[0];
      uploadFile(props.boxName, file)
        .then(() => {
          setLastUploadedFile(file.name);
          setFileError(false);
        })
        .catch(() => {
          setFileError(true);
        });
    },
  });

  const [lastUploadedFile, setLastUploadedFile] = useState('');
  const [fileError, setFileError] = useState(false);

  const [lastUploaded] = useLazyQuery(GETLASTUPLOADEDFILE, {
    fetchPolicy: 'network-only',
  });
  const [uploadedFile] = useMutation(UPLOADFILE, {
    fetchPolicy: 'network-only',
  });

  async function getLastUploadedFile(boxName: string) {
    return await lastUploaded({
      variables: {
        input: {
          boxName: boxName,
        },
      },
    });
  }

  async function uploadFile(boxName: string, file: File) {
    try {
      const response = await uploadedFile({
        variables: {
          input: {
            boxName,
            file,
          },
        },
      });
      console.log('response', response);
      props.myFunction();
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    getLastUploadedFile(props.boxName)
      .then((result) => {
        setLastUploadedFile(result.data.getLastUploaded.name);
      })
      .catch(() => {
        setLastUploadedFile(null);
      });
  }, []);

  const [requestDownload] = useLazyQuery<{
    downloadLastUploaded: { body: string; name: string };
  }>(DOWNLOAD_LAST, {
    fetchPolicy: 'network-only',
  });

  const handleDownload = (boxName: string) => {
    console.log('handleDownload', boxName);

    requestDownload({ variables: { input: { boxName } } })
      .then((res) => {
        console.log('handleDownload:file', res.data);

        downloadFile(
          res.data.downloadLastUploaded.body,
          res.data.downloadLastUploaded.name
        );
        toast({
          title: `File ${res.data.downloadLastUploaded.name} downloaded`,
          status: 'success',
          duration: 9000,
          isClosable: true,
        });
      })
      .catch((err) => {
        console.log(err);
        toast({
          title: 'File not available',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      });
  };

  return (
    <section className={container ? container : 'container'} id={props.boxName}>
      <Heading as={'h3'} fontSize={'2xl'} mb={4}>
        {props.boxName}
      </Heading>
      {fileError ? (
        <h2 className={'uploadFileError'}>File type not valid</h2>
      ) : (
        ''
      )}
      <div {...getRootProps({ className: 'dropzone' })}>
        <p>Drag your file here to upload</p>
      </div>
      {lastUploadedFile ? (
        <Flex justifyContent={'space-between'} alignItems={'center'} my={4}>
          <Text fontSize={'xl'}>
            Last uploaded file is: <strong>{lastUploadedFile}</strong>
          </Text>
          <Button
            variant={'outline'}
            onClick={() => handleDownload(props.boxName)}
          >
            <Icon as={MdDownload} w={6} />
            Download
          </Button>
        </Flex>
      ) : (
        <h4 className={'dropzoneLastFile'}>No file uploaded</h4>
      )}
    </section>
  );
}

export default Dropzone;
